/* eslint-disable import/no-default-export */
import React from 'react';
import ReactDOM from 'react-dom';

export default function makeOfferLauncher(options = {}) {
    const modalContainer = document.createElement('div');
    const {
        currency,
        itemId,
        environment,
        quantitySelected,
        shouldNotSendOfferMessage,
        launchOrigin,
        shouldLaunchContactDealer,
    } = options;
    return import(
        /* webpackChunkName: "makeOfferModal" */
        '../src/MakeOfferModal/makeOfferAsyncImports'
    ).then(mod => {
        const { components, helpers } = mod;

        const { MakeOfferModal, IntlProvider } = components;
        const { serverVars } = helpers;

        ReactDOM.render(
            <IntlProvider
                locale={serverVars.get('locale') || 'en'}
                messages={serverVars.get('messages')}
            >
                <MakeOfferModal
                    launchOrigin={launchOrigin}
                    environment={environment}
                    itemId={itemId}
                    pageCurrency={currency}
                    quantitySelected={quantitySelected}
                    shouldNotSendOfferMessage={shouldNotSendOfferMessage}
                    shouldLaunchContactDealer={shouldLaunchContactDealer}
                />
            </IntlProvider>,
            modalContainer
        );
    });
}
